import {
  QuestionEntityEditorProps,
  SurveyQuestionsField,
} from '@/modules/user-survey/views/UserSurveyEditor/components/BlocksList/types';
import { QuestionTypeEnum } from '@/types/schema';

import SelectEditorOptionsList from '../../components/SelectEditorOptionsList';

const MultiSelectField: SurveyQuestionsField = {
  type: QuestionTypeEnum.MultiSelect,
  Editor: (props: QuestionEntityEditorProps) => (
    <SelectEditorOptionsList isMultiSelect {...props} />
  ),
};

export default MultiSelectField;
